"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginatedResponseBody = exports.paginatedResponseBodySuccess = exports.emptyResponseBody = exports.responseBody = exports.responseBodySuccess = exports.ResponseBodyEmpty = exports.responseBodyError = exports.Success = exports.Failure = exports.Empty = exports.ProtocolError = exports.TooManyRequestsError = exports.EntityExistsError = exports.NotAuthorizedError = exports.NotAuthenticatedError = exports.ForbiddenError = exports.NotFoundError = exports.LegacyValidationError = exports.LegacyInputValidation = exports.LegacyParamValidation = exports.LegacyChainValidation = exports.ValidationError = exports.ValidationIssue = exports.InternalServerError = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const json_1 = require("../../../json");
const pagination_1 = require("../../../pagination");
exports.NAMESPACE = 'Culligan.Api.V2.Protocol';
exports.InternalServerError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('InternalServerError'),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.InternalServerError`,
    description: 'Internal server error',
});
exports.ValidationIssue = effect_1.Schema.Struct({
    path: effect_1.Schema.Array(effect_1.Schema.PropertyKey),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.ValidationIssue`,
});
exports.ValidationError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('ValidationError'),
    message: effect_1.Schema.String,
    issues: effect_1.Schema.Array(exports.ValidationIssue),
}).annotations({
    identifier: `${exports.NAMESPACE}.ValidationError`,
    description: 'Validation error containing issues',
});
exports.LegacyChainValidation = effect_1.Schema.suspend(() => effect_1.Schema.Struct({
    param: effect_1.Schema.tag('_error'),
    msg: json_1.Value,
    nestedErrors: effect_1.Schema.Array(exports.LegacyChainValidation),
})).annotations({
    identifier: `${exports.NAMESPACE}.LegacyChainValidation`,
    description: 'Old way of representing nested validation errors',
});
exports.LegacyParamValidation = effect_1.Schema.Struct({
    location: effect_1.Schema.Literal('body', 'params', 'cookies', 'headers', 'query'),
    param: effect_1.Schema.String,
    value: json_1.Value,
    msg: json_1.Value,
}).annotations({
    identifier: `${exports.NAMESPACE}.LegacyParamValidation`,
    description: 'Old way of representing parameter validation errors',
});
exports.LegacyInputValidation = effect_1.Schema.Union(exports.LegacyChainValidation, exports.LegacyParamValidation).annotations({
    identifier: `${exports.NAMESPACE}.LegacyInputValidation`,
    description: 'Old way of representing validation errors',
});
exports.LegacyValidationError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('LegacyValidationError'),
    message: effect_1.Schema.String,
    inputValidation: effect_1.Schema.Array(exports.LegacyInputValidation),
}).annotations({
    identifier: `${exports.NAMESPACE}.LegacyValidationError`,
    description: 'Legacy validation error containing legacy validation errors',
});
exports.NotFoundError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('NotFoundError'),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.NotFoundError`,
    description: 'Not found error',
});
exports.ForbiddenError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('ForbiddenError'),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.ForbiddenError`,
    description: 'Forbidden error',
});
exports.NotAuthenticatedError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('NotAuthenticatedError'),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.NotAuthenticatedError`,
    description: 'Not authenticated error',
});
exports.NotAuthorizedError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('NotAuthorizedError'),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.NotAuthorizedError`,
    description: 'Not authorized error',
});
exports.EntityExistsError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('EntityExistsError'),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.EntityExistsError`,
    description: 'Entity exists error',
});
exports.TooManyRequestsError = effect_1.Schema.Struct({
    type: effect_1.Schema.tag('TooManyRequestsError'),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.TooManyRequestsError`,
    description: 'Too Many Requests Error',
});
exports.ProtocolError = effect_1.Schema.Union(exports.InternalServerError, exports.ValidationError, exports.LegacyValidationError, exports.NotFoundError, exports.ForbiddenError, exports.NotAuthenticatedError, exports.NotAuthorizedError, exports.EntityExistsError, exports.TooManyRequestsError).annotations({
    identifier: `${exports.NAMESPACE}.ProtocolError`,
    description: 'Union of all possible protocol errors',
});
exports.Empty = { success: true };
const Failure = (error) => ({ success: false, error });
exports.Failure = Failure;
const Success = (data) => ({ success: true, data });
exports.Success = Success;
const responseBodyError = (error) => effect_1.Schema.Struct({
    success: effect_1.Schema.tag(false),
    error: error,
}).annotations({
    title: 'ResponseBodyError',
});
exports.responseBodyError = responseBodyError;
exports.ResponseBodyEmpty = effect_1.Schema.Struct({ success: effect_1.Schema.tag(true) }).annotations({
    identifier: `${exports.NAMESPACE}.ResponseBodyEmpty`,
});
const responseBodySuccess = (data) => effect_1.Schema.Struct({
    success: effect_1.Schema.tag(true),
    data: data,
}).annotations({
    title: 'ResponseBodySuccess',
});
exports.responseBodySuccess = responseBodySuccess;
const responseBody = (data, error) => effect_1.Schema.Union((0, exports.responseBodyError)(error), (0, exports.responseBodySuccess)(data)).annotations({
    title: 'ResponseBody',
});
exports.responseBody = responseBody;
const emptyResponseBody = (error) => effect_1.Schema.Union((0, exports.responseBodyError)(error), exports.ResponseBodyEmpty).annotations({
    title: 'EmptyResponseBody',
});
exports.emptyResponseBody = emptyResponseBody;
const paginatedResponseBodySuccess = (data) => (0, exports.responseBodySuccess)((0, pagination_1.paginate)(data).annotations({ title: 'Page' })).annotations({
    title: 'PaginatedResponseBodySuccess',
});
exports.paginatedResponseBodySuccess = paginatedResponseBodySuccess;
const paginatedResponseBody = (data, error) => effect_1.Schema.Union((0, exports.responseBodyError)(error), (0, exports.paginatedResponseBodySuccess)(data)).annotations({
    title: 'PaginatedResponseBody',
});
exports.paginatedResponseBody = paginatedResponseBody;
//# sourceMappingURL=protocol.js.map